/**
 * @generated SignedSource<<97f469c9e9a409f44d7680be0910d153>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildEventsPastCard_guild$data = {
  readonly id: string;
  readonly pastEvents: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"EventItemNew_event">;
      };
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"EventList_eventsConnection">;
  };
  readonly " $fragmentType": "GuildEventsPastCard_guild";
};
export type GuildEventsPastCard_guild$key = {
  readonly " $data"?: GuildEventsPastCard_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildEventsPastCard_guild">;
};

import GuildEventsPastCardPaginationQuery_graphql from './GuildEventsPastCardPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "pastEvents"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": GuildEventsPastCardPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "GuildEventsPastCard_guild",
  "selections": [
    {
      "alias": "pastEvents",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "START_AT_DESC",
            "ID_ASC"
          ]
        },
        {
          "kind": "Literal",
          "name": "timeSelection",
          "value": "PAST"
        }
      ],
      "concreteType": "EventsConnection",
      "kind": "LinkedField",
      "name": "__GuildEventsPastCard_guild_pastEvents_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EventItemNew_event"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventList_eventsConnection"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__GuildEventsPastCard_guild_pastEvents_connection(orderBy:[\"START_AT_DESC\",\"ID_ASC\"],timeSelection:\"PAST\")"
    },
    (v1/*: any*/)
  ],
  "type": "Guild",
  "abstractKey": null
};
})();

(node as any).hash = "3c499cfb0cc7412bce97ce9d3e825cb9";

export default node;
